<mat-vertical-stepper linear #stepper>
    <mat-step label="Upload CSV file" [completed]="currentState !== ImportVehiclesStateEnum.WAITING_FOR_FILE">
        <input hidden
			   type="file"
               id="file"
               accept=".csv"
               #fileInput
               (change)="handleFileInput($event)">

		@switch (currentState) {
			@case (ImportVehiclesStateEnum.WAITING_FOR_FILE) {
				@if (!showCsvHelp) {
					<div class="row-with-button">
						<div class="text-block">
							Choose a CSV file in a
							<button mat-button
									(click)="showCsvHelp=true">
								supported format
							</button>.
						</div>
						<button mat-stroked-button
								color="accent"
								(click)="fileInput.click()"
						>
							Choose CSV file
						</button>
					</div>
				}
				@else {
					<mat-card>
						<mat-card-header>
							Sample CSV
						</mat-card-header>
						<mat-card-content>
							<p>
								Map Label and License Plate are optional.
							</p>

							<div style="overflow: auto; font-family: monospace; white-space: nowrap">
								name,mapLabel,licensePlate,vGroup<br />
								4431009435,X0035,XE0436-X0035,Truck 4x4<br />
								…<br />
								…
							</div>
						</mat-card-content>
						<mat-card-actions>
							<button mat-stroked-button
									(click)="showCsvHelp=false">
								Close
							</button>
						</mat-card-actions>
					</mat-card>
				}
			}
			@case (ImportVehiclesStateEnum.UPLOADING_FILE) {
            	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			}
			@case (ImportVehiclesStateEnum.UPLOAD_FAILED) {
				<p class="ui-error">{{ uiError }}</p>
				<button mat-stroked-button
						(click)="currentState = ImportVehiclesStateEnum.WAITING_FOR_FILE; fileInput.click()">
					Choose different file
				</button>
			}
			@case (ImportVehiclesStateEnum.UPLOAD_SUCCEEDED) {
				<p>The file <strong>{{selectedFile.name}}</strong> has been uploaded.</p>

				<button mat-stroked-button
						matStepperNext
						color="accent">
					Next
				</button>
			}
		}
    </mat-step>

    <mat-step label="Review data" [completed]="validData?.length">
		@if (!validData?.length && !invalidData?.length) {
			<p>
				No CSV data.
			</p>
		}

		@if (invalidData?.length) {
			<h2>Invalid data</h2>
			<div class="overflow-x-auto">
				<ng-container
						*ngTemplateOutlet="table;context:{importData: invalidData,displayedColumns:displayedColumnsInvalid}"></ng-container>
			</div>
		}

		@if (validData?.length) {
			<h2>Valid data</h2>
			<div class="overflow-x-auto">
				<ng-container
						*ngTemplateOutlet="table;context:{importData: validData,displayedColumns:displayedColumnsValid}"></ng-container>
			</div>
			<div class="mt-8">
				<button mat-stroked-button
						matStepperNext>
					Next
				</button>
			</div>
		}
    </mat-step>

    <mat-step label="Import vehicles">
		@switch (currentState) {
			@case (ImportVehiclesStateEnum.UPLOAD_SUCCEEDED) {
				@if (validData?.length) {
					<p>
						{{ rowsToImport().length }}
						<span [ngPlural]="rowsToImport().length">
							<ng-template ngPluralCase="=1">vehicle</ng-template>
							<ng-template ngPluralCase="other">vehicles</ng-template>
						</span>
						ready to import.
					</p>
				} @else {
					<p>
						No vehicles to import
					</p>
				}
			}
			@case (ImportVehiclesStateEnum.IMPORT_FAILED) {
            	<p class="ui-error">{{ uiError }}</p>
			}
			@case (ImportVehiclesStateEnum.IMPORT_SUCCEEDED) {
            	<p>Import succeeded.</p>
			}
		}
    </mat-step>

</mat-vertical-stepper>

<ng-template #table let-data="importData" let-displayedColumns="displayedColumns">
	@if (data?.length) {
		<table mat-table
			   [dataSource]="data">

			<ng-container matColumnDef="line">
				<th mat-header-cell *matHeaderCellDef> Line</th>
				<td mat-cell *matCellDef="let element">{{element.index}} </td>
			</ng-container>

			<ng-container matColumnDef="name">
				<th mat-header-cell *matHeaderCellDef> Name</th>
				<td mat-cell *matCellDef="let element">{{element.row.name}} </td>
			</ng-container>

			<ng-container matColumnDef="mapLabel">
				<th mat-header-cell *matHeaderCellDef> Map Label</th>
				<td mat-cell *matCellDef="let element">
					{{element.row?.mapLabel}}
					@if (element.vehicle?.mapLabel !== element.row?.mapLabel) {
						<del>{{element.vehicle?.mapLabel}}</del>
					}
				</td>
			</ng-container>

			<ng-container matColumnDef="licensePlate">
				<th mat-header-cell *matHeaderCellDef> License Plate</th>
				<td mat-cell *matCellDef="let element">
					{{element.row?.licensePlate}}
					@if (element.vehicle?.licensePlate !== element.row?.licensePlate) {
						<del>{{element.vehicle?.licensePlate}}</del>
					}
				</td>
			</ng-container>

			<ng-container matColumnDef="vGroup">
				<th mat-header-cell *matHeaderCellDef> Vehicle Group</th>
				<td mat-cell *matCellDef="let element">
					{{element.row?.vehicleGroup}}
					@if (element.vehicleCategory?.title !== element.row?.vehicleGroup) {
						<del>{{element.vehicleCategory?.title}}</del>
					}
				</td>
			</ng-container>

			<ng-container matColumnDef="action">
				<th mat-header-cell *matHeaderCellDef> Action</th>
				<td mat-cell *matCellDef="let element">
					<ng-container *ngTemplateOutlet="action;context:{action:element.action}"></ng-container>
				</td>
			</ng-container>

			<ng-container matColumnDef="errors">
				<th mat-header-cell *matHeaderCellDef> Errors</th>
				<td mat-cell *matCellDef="let element">
					@if (element.errors) {
						@for (error of element.errors //noinspection ForBlockNonIterableVar; track $index) {
							<div class="ui-error">{{error}}</div>
						}
					}
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
	}
</ng-template>

<ng-template #action let-action="action">
	<mat-icon color="accent" [title]="action">
		@if (action === 'CREATE') {
			add_circle
		} @else if (action === 'UPDATE') {
			sync
		}
	</mat-icon>
</ng-template>
